import React from 'react';
import ReactMarkdown, { uriTransformer } from 'react-markdown';

function platformUriTransformer(uri, nextTransformer) {
  if (typeof uri !== 'undefined' && uri.startsWith('contentItem:') && typeof window !== 'undefined') {
    uri = window.location.pathname.split('/').slice(0, 3).join('/') + '/' + uri.substr(uri.indexOf(':') + 1);
  }
  return nextTransformer(uri);
}

function leagcyReactMarkdown({ source, transformLinkUri, className, ...props }) {
  const ret = (
    <ReactMarkdown transformUrl={platformUriTransformer} {...props}>
      {source}
    </ReactMarkdown>
  );
  return className ? <span className={className}>{ret}</span> : ret;
}

export default function PlatformReactMarkdown({ transformLinkUri = uriTransformer, escapeHtml, ...props }) {
  return props.source ? leagcyReactMarkdown(props) : <ReactMarkdown transformUrl={platformUriTransformer} {...props} />;
}
